import React, { useEffect, useRef, useState } from 'react';
import "./style.less";
import { Icon } from 'antd';

function Comment({ title = "写留言", visible = false, onClose, onSubmit }) {

    const input = useRef();
    const [content, setContent] = useState();

    useEffect(() => {
        if (visible) input.current.focus();
    }, [visible])

    const _onSubmit = () => {
        if (!content) return onClose();
        onSubmit(content);
        setContent("");
        onClose();
    }

    return (
        <div className={`com-commentInput  ${visible && "com-commentInput--visible"}`}>
            <div onClick={onClose} className="com-commentInput__dark"></div>
            <div className={`com-commentInput__main`}>
                <div className="flex between">
                    <Icon type="close" onClick={onClose} />
                    <p>{title}</p>
                    <Icon type="check" onClick={_onSubmit} />
                </div>
                <textarea ref={input} value={content} onChange={e => setContent(e.target.value)} className="com-commentInput__content" placeholder="留言与他人分享吧！" rows={5} type="text" />
            </div>
        </div>
    )
}

export default Comment;